import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Overview from './Overview';
import SwatchList from './SwatchList';

const PdpProductMobileSelector = ({
  products,
  currentProductLabel,
  currentProductName,
  isSalePdp,
  ...otherProps
}) => {
  const compareAtPrice = get(products, ['0', 'formattedCompareAtPrice']);

  return (
    <div className="PdpProductSelectorMobile">
      <Overview
        label={currentProductLabel}
        name={currentProductName}
        compareAtPrice={compareAtPrice}
        isSalePdp={isSalePdp}
      />
      <SwatchList products={products} swatchAngle={135} {...otherProps} />
    </div>
  );
};

PdpProductMobileSelector.propTypes = {
  isLoading: PropTypes.bool,
  products: PropTypes.arrayOf(PropTypes.shape({})),
  onSelect: PropTypes.func.isRequired,
  currentProductLabel: PropTypes.string,
  currentProductName: PropTypes.string,
  currentProductHandle: PropTypes.string,
  isSalePdp: PropTypes.bool.isRequired,
};

PdpProductMobileSelector.defaultProps = {
  isLoading: false,
  products: {},
  currentProductLabel: null,
  currentProductName: null,
  currentProductHandle: null,
};

export default PdpProductMobileSelector;
